<button
  type="button"
  class="touch-checkbox"
  role="checkbox"
  [attr.aria-checked]="checked()"
  [attr.aria-label]="label()"
  (click)="onToggle()"
>
  <span class="touch-checkbox__box" aria-hidden="true">
    @if (checked()) {
      <img src="assets/img/icon-check-white.svg" alt="" width="20" height="15" />
    }
  </span>
  <span class="touch-checkbox__label">{{ label() }}</span>
</button>
